<div class="h-100 d-flex flex-column">
	<div class="h-100 d-flex align-items-center justify-content-center">
		<div class="h-100 w-100 pt-3 mt-1">
			<ng-content></ng-content>
		</div>
	</div>
	@if (link !== undefined) {
		<div class="flex-grow-1 d-flex justify-content-end">
			@if (!link.restricted && !link.isNewWindow) {
				<a
					[routerLink]="link.route"
					[class.invisible]="link.invisibleWhenEmptyRoute && link.route === ''"
					class="d-flex app-link-dark pe-2 pb-2"
					(click)="click($event)">
					<div>
						{{ link.linkNameKey | translate }}
					</div>
					@if (link.isJumpOff) {
						<div class="mask-settings open-in-new-mask-img"></div>
					}
				</a>
			}
			@if (!link.restricted && link.isNewWindow) {
				<a
					[href]="this.link.route"
					[class.invisible]="link.invisibleWhenEmptyRoute && link.route === ''"
					rel="noreferrer"
					target="_blank"
					class="d-flex app-link-dark pe-2 pb-2"
					(click)="click($event)">
					<div>
						{{ link.linkNameKey | translate }}
					</div>
					<div class="mask-settings open-in-new-mask-img"></div>
				</a>
			}
			@if (link.restricted) {
				<a [href]="" rel="noreferrer" class="d-flex app-link-dark pe-2 pb-2" (click)="click($event)">
					<div>
						{{ link.linkNameKey | translate }}
					</div>
					@if (link.isJumpOff || link.isNewWindow) {
						<div class="mask-settings open-in-new-mask-img"></div>
					}
				</a>
			}
		</div>
	}
</div>
